import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import {
    renderFieldSelect,
    requiredSelect,
    maxValueMonetario,
    renderFieldMonetarioLabelEncima,
    required,
    renderField
} from '../../util/inputs';
import { tipoCustoItinerario } from '../../util/constantsUtil';
import cadastrarCustoItinerario from '../../actions/itinerario/cadastrarCustoItinerario';
import buscarCustoItinerario from '../../actions/itinerario/buscarCustoItinerario';
import $ from 'jquery';
import {showSuccessMsg} from '../../util/messagesUtil';

export class ModalNovaEntradaOuSaidaCustoItinerario extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listaEntradaSaida: []
        }
    }

    gerarHashForString(texto) {
        let hash = 0;
        if (texto.length == 0) return hash;
        for (let i = 0; i < texto.length; i++) {
            let char = texto.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash;
        }
        return hash;
    }

    adicionarItem(event) {
        event.preventDefault();
        const tipoCustoItinerario = this.props.tipoCustoItinerario ? this.props.tipoCustoItinerario.value : null;

        const hashDosItensPreenchido = this.gerarHashForString(`${tipoCustoItinerario}${this.props.valor}${this.props.descricao}`)

        if (this.state.listaEntradaSaida.filter(it => it.hash === hashDosItensPreenchido).length === 0) {
            const listaEntradaSaida = this.state.listaEntradaSaida;
            listaEntradaSaida.push({
                hash: hashDosItensPreenchido,                
                tipo: tipoCustoItinerario,
                valor: this.props.valor ? this.props.valor.replace('R$', '') : null,
                descricao: this.props.descricao
            });
            this.setState({ listaEntradaSaida: listaEntradaSaida })
        }        
    }

    removerItemSelecionado(hash) {
        this.setState({listaEntradaSaida: this.state.listaEntradaSaida.filter(it => !(it.hash === hash))})
    }

    exibirTabela() {
        return (
            <div className='col-12 mt-2'>
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Entrada/Saída</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Descrição</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.listaEntradaSaida.length === 0 ? 
                            <tr className="alert alert-warning text-center mt-4" role="alert">
                                <td colSpan='4'>
                                    Nenhum item adicionado.
                                </td>
                            </tr>
                            : this.state.listaEntradaSaida.length && this.state.listaEntradaSaida.map(it => (
                                <tr key={it.hash}>
                                    <td>{it.tipo}</td>
                                    <td>{it.valor}</td>
                                    <td>{it.descricao}</td>
                                    <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                                        <div onClick={() => this.removerItemSelecionado(it.hash)}>
                                            Remover
                                        </div>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        )
    }

    submit() {
        this.props.cadastrarCustoItinerario(this.props.itinerarioSelecionado.id,
            this.props.empresaSelecionada.id, this.props.idUsuario, this.state.listaEntradaSaida)
                .then(() => {
                    this.props.buscarCustoItinerario(this.props.itinerarioSelecionado.id);
                    this.fecharModal();
                    showSuccessMsg('As entradas/saídas foram salvos com sucesso!');
                });
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        return (
            <>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    <div className="form-row">
                        <div className="col-12 col-sm-3 col-md-3 mt-2">
                            <Field name='tipoCustoItinerario'
                                options={tipoCustoItinerario.map(elemento => ({
                                    descricao: elemento.label,
                                    nome: elemento.value
                                }))}                                
                                component={renderFieldSelect}
                                label="Entrada/Saída:"
                                placeholder='Selecione um tipo' validate={requiredSelect} />
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 mt-2">
                            <Field name="valor" validate={[required, maxValueMonetario]}
                                component={renderFieldMonetarioLabelEncima}
                                label="Valor:" />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4 mt-2">
                            <Field name="descricao" type="text" component={renderField} label="Descrição:"
                                validate={[required]} css="form-control" />
                        </div>
                        <div className="col-12 col-sm-2 col-md-2 d-flex align-items-center" style={{ marginTop: '40px'}}>
                            <button disabled={invalid || submitting || this.props.valor === 'R$0,00'}
                                type="submit" className="btn btn-sm btn-laranja"
                                onClick={(e) => this.adicionarItem(e)}>Incluir
                            </button>
                        </div>
                    </div>
                    <div className="form-row">                        
                        {this.exibirTabela()}
                    </div>
                    <div className="modal-footer">
                        <button type="submit"
                            disabled={this.state.listaEntradaSaida.length === 0}
                            className="btn btn-laranja">Salvar</button>
                    </div>
                </form>
            </>
        )
    }

    limparFormulario() {
        this.props.reset('formularioNovaEntradaOuSaidaCustoItinerario');
        this.setState({ listaEntradaSaida: [] })
    }

    fecharModal() {
        $('#modalNovaEntradaOuSaidaCustoItinerario')
            .modal('hide');
        $('#modalNovaEntradaOuSaidaCustoItinerario')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }   


    render() {
        return (
            <div className="modal fade show" id='modalNovaEntradaOuSaidaCustoItinerario' role='dialog'
                aria-labelledby='modalNovaEntradaOuSaidaCustoItinerario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Custo Itinerário</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario.bind(this)}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {

    return {
        initialValues: {
            tipoCustoItinerario: {
                label: tipoCustoItinerario[0].label,
                value: tipoCustoItinerario[0].value
            }                    
        },
        itinerarioSelecionado: state.itinerarioSelecionado,
        idUsuario: state.authentication.idUsuario,
        empresaSelecionada: state.empresaSelecionada,
        tipoCustoItinerario: formValueSelector('formularioNovaEntradaOuSaidaCustoItinerario')(state, 'tipoCustoItinerario'),
        valor: formValueSelector('formularioNovaEntradaOuSaidaCustoItinerario')(state, 'valor'),
        descricao: formValueSelector('formularioNovaEntradaOuSaidaCustoItinerario')(state, 'descricao'),

    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({                
        cadastrarCustoItinerario,
        buscarCustoItinerario
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioNovaEntradaOuSaidaCustoItinerario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalNovaEntradaOuSaidaCustoItinerario));